import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Button from "../../../../components/Button";
import image from "../../../../image/login.svg";
import { validateHash } from "../../service/index";
import "./index.scss";
import useAuthData from "../../../../hook/useAppData";

export const WelcomeIntegraAdmin = () => {
  const { setToken, userName } = useAuthData();
  const { hash } = useParams<{ hash }>();

  useEffect(() => {
    validHash();
  }, []);

  async function validHash() {
    const hashValid = await validateHash(hash);
    setToken(hashValid.token);
  }

  return (
    <>
      <div className="w-screen screen flex flex-col justify-center items-center">
        <img src={image} className="w-1/3" />
        <h1 className="text-5xl font-bold">Bem vindo ao Integra Admin, {userName}</h1>
        <p className="w-1/3 text-center text-2xl text-textPrimary my-5">
          Sua conta foi validada com sucesso e seu ambiente já está pronto te esperando. Vamos lá?
        </p>
        <Link to={"/login"}>
          <Button className="flex bg-primary w-auto px-60">Acessar Integra Admin</Button>
        </Link>
      </div>
    </>
  );
};
